module.exports = __webpack_public_path__ + "img/GR.c93c29be.svg";